import { FC } from 'react'
import type AvatarProps from './types'
import clsx from 'clsx'
import { Typography } from '../Typography'

export const Avatar: FC<AvatarProps> = ({
  initials = '',
  background = 'bg-contrast',
  textClassName = 'text-white',
  removeHoverEffect,
}) => (
  <div
    className={clsx('inline-flex h-10 w-10 rounded-full p-1', {
      'hover:bg-default-hover': !removeHoverEffect,
    })}
  >
    <div
      className={clsx(
        {
          'bg-low animate-pulse': initials === '',
          [background]: initials !== '',
        },
        'flex h-full w-full items-center justify-center rounded-full transition border border-default',
      )}
    >
      {initials !== '' && (
        <Typography
          className={clsx('uppercase', textClassName)}
          size="sm"
          weight="semibold"
        >
          {initials}
        </Typography>
      )}
    </div>
  </div>
)
